import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { autoOpenRegister } from "../ReduxToolkit/Reducers/CartReducer";

export const useRegisterManager = () => {
  const { registers, register_id } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  useEffect(() => {
    // Only proceed if registers have been loaded
    if (registers.length === 0) return;
    
    const openRegister = registers.find(
      (reg) => reg.status === "open"
    );

    // Auto-open register if no open register exists
    if (!openRegister) {
      dispatch(autoOpenRegister());
    }
  }, [registers, dispatch]);
};
